import React from "react";
import {AprsLogbook} from "./AprsLogbook";

const AprsLogbookPage = () => {
  return (
      <AprsLogbook />
  );
}

export default AprsLogbookPage;